import { useState } from "react";
import { toast } from "sonner";
import { post, errMsg } from "@/lib/api";
import { btnAmber, btnGhost, btnPrimary, Field, inputCls } from "@/components/common";

export function DecisionForm({ event, onDone }) {
  const [decision, setDecision] = useState("INCONCLUSIVE");
  const [rationale, setRationale] = useState("");
  const [runId, setRunId] = useState("");
  const [busy, setBusy] = useState(false);
  const completed = (event.attribution_runs || []).filter((r) => r.run_state === "COMPLETED");
  const closed = event.state === "CLOSED";

  const submit = async (e) => {
    e.preventDefault();
    if (rationale.trim().length < 10) return toast.error("Rationale must be at least 10 characters");
    setBusy(true);
    try {
      await post(`/events/${event.event_id}/decisions`, { decision, rationale: rationale.trim(), attribution_run_id: runId || null });
      toast.success(`Decision recorded: ${decision.replace("_", " ")}`);
      setRationale("");
      onDone?.();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="decision-form" className="space-y-3">
      <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Decision">
        {[["VERIFIED", "Verified", btnPrimary], ["NOT_VERIFIED", "Not verified", btnGhost], ["INCONCLUSIVE", "Inconclusive", btnAmber]].map(([v, l, cls]) => (
          <button type="button" key={v} role="radio" aria-checked={decision === v} data-testid={v === "INCONCLUSIVE" ? "event-inconclusive-button" : `decision-${v.toLowerCase()}-button`} onClick={() => setDecision(v)}
            className={`${cls} justify-center ${decision === v ? "ring-2 ring-offset-2 ring-offset-[#11241C] ring-lime-400" : "opacity-60"}`}>{l}</button>
        ))}
      </div>
      <Field label="Linked attribution run (optional)">
        <select data-testid="decision-run-select" value={runId} onChange={(e) => setRunId(e.target.value)} className={inputCls}>
          <option value="">— none —</option>
          {completed.map((r) => <option key={r.run_id} value={r.run_id}>{r.run_id} · {r.method_version} · {r.status}</option>)}
        </select>
      </Field>
      <Field label="Rationale (min 10 chars, append-only)">
        <textarea data-testid="decision-rationale-input" value={rationale} onChange={(e) => setRationale(e.target.value)} rows={4} className={`${inputCls} h-auto py-2`} placeholder="State what evidence supports or contradicts the candidates, and why the case is (not) verifiable…" />
      </Field>
      <button type="submit" disabled={busy || closed} data-testid="event-decision-submit-button" className={`${btnPrimary} w-full justify-center`}>{closed ? "Event closed" : busy ? "Recording…" : "Record decision"}</button>
      <p className="text-[11px] text-slate-500">A human decision is the only route to “Verified”. Re-running attribution later never alters this record.</p>
    </form>
  );
}
